import * as React from 'react'
import { usePwaInstallStore } from '@/modules/pwa/stores/pwaInstallStore'

export function usePwaInstall() {
  const canInstall = usePwaInstallStore((s) => s.canInstall)
  const installing = usePwaInstallStore((s) => s.installing)
  const installed = usePwaInstallStore((s) => s.installed)
  const isIosSafari = usePwaInstallStore((s) => s.isIosSafari)
  const hasPrompt = usePwaInstallStore((s) => !!s.deferred)

  const promptInstall = React.useCallback(async () => {
    const state = usePwaInstallStore.getState()
    const deferred = state.deferred
    if (!deferred) return { outcome: 'dismissed' as const }
    try {
      state.setInstalling(true)
      await deferred.prompt()
      const choice = await deferred.userChoice
      if (choice?.outcome === 'accepted') state.setInstalled(true)
      return choice
    } finally {
      const st = usePwaInstallStore.getState()
      st.setInstalling(false)
      st.setDeferred(null)
    }
  }, [])

  return { canInstall, installing, installed, isIosSafari, hasPrompt, promptInstall }
}
